// export const API_URI = `http://192.168.1.15:8085`; //赵磊本机
// export const API_URI = 'http://192.168.1.39:8085'; // 许伦杰本机

export const API_URI = `http://creative.adamroi.com/api`; //正式环境
export const UPLOAD_ALLOW_SUFFIX_LIST = ['.jpg', '.jpeg', '.mp4', '.png', '.mov', '.gif', '.psd'];
